import { formatDateTime, InfoIcon, Link } from '@hypothesis/frontend-shared';
import classnames from 'classnames';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "preact/jsx-runtime";
/**
 * Information to display in a Popover when hovering over a processed mention.
 */
export default function MentionPopoverContent(_ref) {
  var content = _ref.content,
    mentionMode = _ref.mentionMode;
  var isUsernameMode = mentionMode === 'username';
  return _jsxs(_Fragment, {
    children: [_jsx("div", {
      className: "px-3 py-2",
      children: typeof content === 'string' ? _jsxs("div", {
        "data-testid": "user-not-found",
        children: ["User ", _jsx("span", {
          className: "font-bold",
          children: content
        }), " does not exist or does not have access to this group"]
      }) : _jsxs("div", {
        className: "flex flex-col gap-y-4",
        children: [_jsxs("div", {
          className: "flex flex-col gap-y-1.5",
          children: [isUsernameMode && _jsxs("div", {
            "data-testid": "username",
            className: "text-md font-bold",
            children: ["@", content.username]
          }), content.display_name && _jsx("div", {
            "data-testid": "display-name",
            className: classnames({
              'text-color-text-light': isUsernameMode,
              'text-md font-bold': !isUsernameMode
            }),
            children: content.display_name
          })]
        }), content.description && _jsx("div", {
          "data-testid": "description",
          className: "line-clamp-2",
          children: content.description
        }), content.joined && _jsxs("div", {
          "data-testid": "joined",
          className: "text-color-text-light",
          children: ["Joined", ' ', _jsx("b", {
            children: formatDateTime(content.joined, {
              includeTime: false
            })
          })]
        })]
      })
    }), _jsx("div", {
      className: "px-3 py-2 border-t",
      children: _jsxs(Link, {
        variant: "text-light",
        classes: "flex gap-x-1 items-center",
        target: "_blank",
        href: isUsernameMode ? 'https://web.hypothes.is/help/mentions-for-the-hypothesis-web-app/' : 'https://web.hypothes.is/help/mentions-for-the-hypothesis-lms-app/',
        "data-testid": "kb-article-link",
        children: [_jsx(InfoIcon, {
          className: "w-3 h-3"
        }), " Learn more about @mentions"]
      })
    })]
  });
}
//# sourceMappingURL=MentionPopoverContent.js.map